import React from "react";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Logo from "../components/Logo";

// Styled Header
const HeaderStyle = styled("header")(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: "100%",
  position: "absolute",
  padding: theme.spacing(3, 3, 0),
  display: "flex",
  justifyContent: "center",
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(5, 5, 0),
    justifyContent: "flex-start", // Logo aligns to the left on larger screens
  },
}));

const MainStyle = styled("main")(({ theme }) => ({
  marginTop: theme.spacing(20), // Ensure space for the logo
  padding: theme.spacing(3),
}));

export default function LogoOnlyLayout() {
  return (
    <>
      <HeaderStyle>
        <Logo sx={{ height: "150px", width: "150px" }} />
      </HeaderStyle>
      <MainStyle>
        <Outlet />
      </MainStyle>
    </>
  );
}
